import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface CaucionGeneralIntroScreenProps {
	onNext: () => void
}

export function CaucionGeneralIntroScreen({
	onNext,
}: CaucionGeneralIntroScreenProps) {
	return (
		<div className="flex h-full w-full flex-col gap-6 overflow-hidden">
			<div className="flex w-full items-center justify-start gap-3">
				<div className="flex items-center justify-center gap-2.5 rounded-lg bg-green-50 p-2 md:rounded-xl">
					<Icon name="file-text" className="size-4 text-green-800 md:size-5" />
				</div>
				<div className="flex flex-1 flex-col items-start justify-start gap-1">
					<p className="font-parkinsans w-full text-sm leading-5 font-medium text-green-800 md:text-lg md:leading-8">
						Caución General
					</p>
				</div>
			</div>

			<div className="relative h-28 w-full overflow-hidden rounded-xl bg-gradient-to-r from-blue-500 to-green-500 md:h-56">
				<div className="pointer-events-none absolute -top-[553px] -left-[263px] h-[calc(1px*((961*0.7071067690849304)+(917*0.7071067690849304)))] w-[calc(1px*((917*0.7071067690849304)+(961*0.7071067690849304)))] opacity-10">
					<div className="h-full w-full -rotate-45 bg-[repeating-linear-gradient(0deg,transparent,transparent_20px,white_20px,white_21px)]" />
				</div>
			</div>

			<div className="flex w-full flex-1 flex-col gap-4">
				<h1 className="font-parkinsans w-full text-base leading-5 font-medium text-blue-800 md:text-3xl md:leading-10">
					Seguro de Caución para Licitaciones y Contratos
				</h1>
				<p className="font-parkinsans w-full text-sm leading-5 font-normal text-neutral-900 md:text-base md:leading-8">
					Garantiza el cumplimiento de obligaciones contractuales con organismos
					públicos y privados. Ideal para licitaciones, contratos de ejecución,
					servicios, suministro y más.
				</p>
				<div className="rounded-lg bg-blue-50 p-3">
					<p className="font-parkinsans text-xs text-blue-800 md:text-sm">
						<strong>Tipos disponibles:</strong> Garantía de Contrato, Servicio,
						Suministro, Contrataciones y Concesiones, Judiciales.
					</p>
				</div>
			</div>

			<div className="flex w-full items-center justify-end gap-1">
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={onNext}
					className="w-full md:w-auto"
				>
					Cotizar ahora
				</Button>
			</div>
		</div>
	)
}
